import React from "react";

export default function MessageToolbar({
  onCopy,
  onRegenerate,
  onLike,
  onDislike,
}) {
  const buttonStyle = {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: "6px 10px",
    borderRadius: 8,
    color: "#6b7280",
    fontSize: 14,
    transition: "all .2s ease",
  };

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        marginTop: 16,
        paddingTop: 12,
        borderTop: "1px solid #e5e7eb",
        flexWrap: "wrap",
      }}
    >
      <button
        style={buttonStyle}
        onClick={onCopy}
        title="Copy response"
      >
        📋 Copy
      </button>

      <button
        style={buttonStyle}
        onClick={onRegenerate}
        title="Regenerate"
      >
        🔄 Regenerate
      </button>

      <button
        style={buttonStyle}
        onClick={onLike}
        title="Helpful"
      >
        👍
      </button>

      <button
        style={buttonStyle}
        onClick={onDislike}
        title="Not helpful"
      >
        👎
      </button>
    </div>
  );
}